export default __webpack_public_path__ + "static/media/case1.412efe89.jpg";